import { render, staticRenderFns } from "./Lootbox.vue?vue&type=template&id=ebc274a6&"
import script from "./Lootbox.vue?vue&type=script&lang=js&"
export * from "./Lootbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports